import { locale, onChangeLocale } from '@signavio/i18n';
const availableLocales = {
  en_US: 'en-US',
  en_GB: 'en-GB',
  de_DE: 'de',
  es_ES: 'es',
  fr_FR: 'fr',
  zh_CN: 'zh-CN',
  ja_JP: 'ja',
  pt_BR: 'pt-BR',
  it_IT: 'it',
  ko_KR: 'ko'
};
let dateFnsLocale;
export const getDateFnsLocale = () => dateFnsLocale;
const updateLocale = () => {
  const currentLocale = availableLocales[locale()] || availableLocales.en_US;

  // @ts-ignore: none of the `module` options in tsconfig workout to enable dynamic import
  // it works well in browser, since we compile with babel
  void import(`date-fns/locale/${currentLocale}/index.js`).then(({
    default: defaultExport
  }) => {
    dateFnsLocale = defaultExport;
  });
};
updateLocale();
onChangeLocale(updateLocale);